export const SET_PAYMENT_METHOD = "SET_PAYMENT_METHOD";
